import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

import withStyles from "@material-ui/core/styles/withStyles";
import CssBaseline from "@material-ui/core/CssBaseline";

import {
  OSSAppHeader,
  OSSAppsMenu,
  OSSEnvBanner,
  OSSBreadcrumbsProvider,
  OSSNotFound,
  OSSUserMenu,
  useAuth,
  useLogout
} from "@oss/components";

import { SDFActionsProvider } from "./context/SDFActionsContext";

const Start = lazy(() => import("./routes/Start/Start"));
const Upload = lazy(() => import("./routes/Upload/Upload"));
const Select = lazy(() => import("./routes/Select/Select"));
const Confirm = lazy(() => import("./routes/Confirm/Confirm"));
const Guide = lazy(() => import("./routes/Guide/Guide"));
const Feedback = lazy(() => import("./routes/Feedback/Feedback"));

const styles = theme => ({
  menuLinks: {
    padding: theme.spacing(2)
  },
  main: {
    width: "100%",
    margin: "0 auto",
    padding: theme.spacing(2)
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: process.env.NODE_ENV === "production",
      refetchOnWindowFocus: process.env.NODE_ENV === "production"
    }
  }
});

const Root = ({ classes }) => {
  //getting the user object from the auth context provider
  const user = useAuth();
  const callLogout = useLogout();

  return (
    <QueryClientProvider client={queryClient}>
      <CssBaseline />
      <OSSBreadcrumbsProvider>
        <Router>
          <>
            <OSSEnvBanner environment={window.APP_ENV} />
            <OSSAppHeader user={user}>
              <OSSAppHeader.Right>
                <OSSAppsMenu user={user} />
                <OSSUserMenu userEmail={user.email} logout={callLogout} />
              </OSSAppHeader.Right>
            </OSSAppHeader>
            <div className={classes.main}>
              <Suspense fallback={<div>Loading...</div>}>
                <SDFActionsProvider>
                  <Switch>
                    <Route exact path="/" component={Start} />
                    <Route exact path="/upload" component={Upload} />
                    <Route exact path="/select" component={Select} />
                    <Route exact path="/confirm" component={Confirm} />
                    <Route exact path="/guide" component={Guide} />
                    <Route exact path="/support" component={Feedback} />
                    <Route component={OSSNotFound} />
                  </Switch>
                </SDFActionsProvider>
              </Suspense>
            </div>
          </>
        </Router>
      </OSSBreadcrumbsProvider>
    </QueryClientProvider>
  );
};

export default withStyles(styles)(Root);
